export interface TenantsFilters {
  tenantName: string;
  locationCity: string;
  locationState: string;
  locationCountry: string;
  showInactiveTenants: boolean;
  productType: string;
}

export const defaultFilters: TenantsFilters = {
  tenantName: '',
  locationCity: '',
  locationState: '',
  locationCountry: '',
  showInactiveTenants: false,
  productType: '',
};
